export default __webpack_public_path__ + "static/media/freeDeliveryAfterThreshold.6e41af17.webp";